import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleEnum, RoleNameEnum } from '../../enums/role.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  
  showFiller = false;
  @Input() iconClick: any
  roleId: string = '';
  userData:any
  userName:string = '';
  isAdmin:boolean=false;
  isTeamlead: boolean = false;
  newRoleId? : number;
  isDepartmentAdmin: boolean = false;
  isHr: boolean = false;
  readonly RoleEnum = RoleEnum;

  isSuperAdmin : boolean = false;

  constructor(private route:Router){}

  ngOnInit(): void {
    this.getStorageData()
  }
  
  getStorageData(){
    this.roleId = sessionStorage.getItem('roleId')?? '';
    let user:any = sessionStorage.getItem("userData");
    this.userData = JSON.parse(user);
    this.newRoleId = Number(this.roleId);
    if(this.userData){
      this.userName = this.userData.userName;
    }
    this.isAdmin = this.userData.roleId == RoleEnum.ADMIN;
    this.isTeamlead = this.userData.roleId == RoleEnum.TEAMLEAD;
    this.isDepartmentAdmin = this.userData.roleId == RoleEnum.DEPARTMENT_ADMIN;
    this.isHr = this.userData.roleId == RoleEnum.HR || `${this.userData.role ?? this.userData.roleName ?? ''}`.trim().toLowerCase() == RoleNameEnum.HR.toLowerCase();

    this.isSuperAdmin = this.userData.userName == 'admin';
  }

  onLogOut(){
    this.route.navigate(['']);
    sessionStorage.clear();
    sessionStorage.clear();
  }

  videoUrl: string = '/Timesheet_Help.mp4';

  playVideo() {
    const videoHtml = `
      <html>
        <head><title>Help Video</title></head>
        <body style="margin:0">
          <video width="100%" height="100%" controls autoplay muted>
            <source src="${this.videoUrl}" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </body>
      </html>
    `;
    const newTab = window.open('', '_blank');
    if (newTab) {
      newTab.document.write(videoHtml);
      newTab.document.close();
    } else {
      alert('Pop-up blocked. Please allow pop-ups for this site.');
    }
  }
}
